import React from 'react';
import { C } from '../theme';

export function Card({ children, style }) {
  return (
    <div style={{ background: C.bg2, border: `1px solid ${C.border}`, borderRadius: 16, padding: 22, marginBottom: 14, ...style }}>
      {children}
    </div>
  );
}

export function CardTitle({ children }) {
  return (
    <div style={{ fontFamily: 'Amiri, serif', fontSize: 16, color: C.gold, marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10 }}>
      {children}
      <div style={{ flex: 1, height: 1, background: `linear-gradient(to left, transparent, ${C.goldDim})` }} />
    </div>
  );
}

export function RCard({ children, type = 'default', style }) {
  const colors = { pos: C.green, warn: C.red, spi: C.purple, ai: C.accent, default: C.gold };
  return (
    <div style={{
      background: type === 'ai' ? `linear-gradient(135deg, ${C.bg2}, #0E0E22)` : C.bg2,
      borderRadius: 14, padding: '16px 18px', marginBottom: 12,
      border: `1px solid ${C.border}`,
      borderRight: `3px solid ${colors[type] || C.gold}`,
      ...style,
    }}>
      {children}
    </div>
  );
}

export function QuoteBox({ text, src }) {
  return (
    <div style={{ background: C.bg3, border: `1px solid ${C.border}`, borderRight: `3px solid ${C.goldDim}`, borderRadius: 12, padding: '16px 18px', marginBottom: 16 }}>
      <p style={{ fontFamily: 'Amiri, serif', fontSize: 15, color: '#F0C96A', lineHeight: 1.8, fontStyle: 'italic', margin: 0 }}>"{text}"</p>
      {src && <span style={{ fontSize: 10, color: C.text2, display: 'block', marginTop: 6 }}>— {src}</span>}
    </div>
  );
}

export function Badge({ children, blue }) {
  return (
    <span style={{ background: blue ? 'rgba(91,127,212,.1)' : 'rgba(212,168,71,.08)', border: `1px solid ${blue ? C.accent : C.goldDim}`, borderRadius: 5, padding: '2px 7px', fontSize: 10, color: blue ? '#8AAAE8' : C.text2 }}>
      {children}
    </span>
  );
}

export function FinInput({ style, ...props }) {
  return (
    <input style={{ width: '100%', background: '#13132A', border: '1px solid #1E1E3A', borderRadius: 12, padding: '13px 16px', color: '#EDE8D8', fontFamily: 'Cairo, sans-serif', fontSize: 14, outline: 'none', boxSizing: 'border-box', ...style }} {...props} />
  );
}

export function BtnPrimary({ children, style, ...props }) {
  return (
    <button style={{ width: '100%', background: 'linear-gradient(135deg, #8B6420, #D4A847)', border: 'none', borderRadius: 14, padding: 15, color: '#0D0A00', fontFamily: 'Cairo, sans-serif', fontSize: 15, fontWeight: 700, cursor: 'pointer', marginTop: 8, transition: 'all .25s', letterSpacing: .5, ...style }} {...props}>
      {children}
    </button>
  );
}
